import * as React from 'react';
import {useForm, Path, UseFormRegister, SubmitHandler} from 'react-hook-form';
import BlogPostSelectSeasonV3 from './BlogPostSelectSeasonV3';
import BlogPostSelectCompBaseV2 from './BlogPostSelectCompBaseV2';
import BlogPostSelectRoundBaseV2 from './BlogPostSelectRoundBaseV2';
import {BlogPostTextInputV2} from './BlogPostTextInputV2';
import {BlogPostNumberInput} from './BlogPostNumberInput';
import {BlogPostCheckBox} from './BlogPostCheckBox';
import {BlogPostSelectCategories} from './BlogPostSelectCategories';
//import BlogPostSelectRoundBaseV2 from './BlogPostSelectRoundBaseV2';
import {getFACompByType, getFAComp} from '@nls-2022/nls-bll';
import {FACompBlogContentType} from '@nls-2022/nls-bll';
import BlogPostSelectCompBase from './BlogPostSelectCompBase';
import {generateBlogPostContentFromCompBlogPost} from '@nls-2022/nls-bll';

export type BlogPostNewFACompInputFormPropsType = {
  blogPost: FACompBlogContentType;
  initInputForm: boolean;
  setInitInputForm: any;
  setGeneratedBlogPostContent: any;
};

export interface ICompInputFormValues {
  Season: string;
  Comp: string;
  Round: string;
  Title: string;
  RoundDate: string;
  NoOfTies: number;
  WinnerPrizeMoney: number;
  LoserPrizeMoney: number | null;
  OtherText: string;
  rest: any;
  IsPublished: boolean;
  Categories: Array<string>;
  PubDate: string;
}

export type InputProps = {
  label: Path<ICompInputFormValues>;
  register: UseFormRegister<ICompInputFormValues>;
  required: boolean;
  rest: any;
};
const publishDaysFactor: number = 5;
const formatDate = (date: string): string => {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [year, month, day].join('-');
};
const publishedDate = (_date: string): string => {
  let convertedDate = new Date(_date);
  convertedDate.setDate(convertedDate.getDate() - publishDaysFactor);
  return formatDate(convertedDate.toDateString());
};

const BlogPostNewFACompInputFormV2 = ({
  //setGeneratedBlogPost,
  blogPost,
  initInputForm,
  setInitInputForm,
  setGeneratedBlogPostContent,
}: //initInputForm,
BlogPostNewFACompInputFormPropsType) => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: {errors},
  } = useForm<ICompInputFormValues>();
  //alert('render BlogPostNewFACompInputForm' + blogPost.roundName);
  console.log('Input Form V2 ' + watch('Round'));
  console.log('Input Form V2 categories' + blogPost.categories);
  console.log('Blog Post RoundName ' + blogPost.roundName);
  const [updatedBlogPost, setUpdatedBlogPost] = React.useState(blogPost);
  const selectedSeason = watch('Season', blogPost.season);
  //const [selectedSeason, setSelectedSeason] = React.useState(blogPost.season);
  const selectedComp = watch('Comp', getFACompByType(blogPost!.comp)!.name);
  //const [selectedComp, setSelectedComp] = React.useState(
  //  getFACompByType(blogPost!.comp)!.name,
  //);
  const selectedCategories = watch('Categories', blogPost.categories);
  const selectedRound = watch('Round', blogPost.roundName);
  const selectedIsPublished = watch('IsPublished', blogPost.isPublished);
  //const [selectedRound, setSelectedRound] = React.useState(blogPost.roundName);
  const selectedTitle = watch('Title', blogPost.title);
  //const [title, setTitle] = React.useState(blogPost.title);
  const selectedPubDate = watch(
    'PubDate',
    blogPost.pubDate !== ''
      ? blogPost.pubDate
      : publishedDate(blogPost.roundDate),
  );
  const selectedRoundDate = watch('RoundDate', blogPost.roundDate);
  //const [roundDate, setRoundDate] = React.useState(blogPost.roundDate);
  const selectedNoOfTies = watch('NoOfTies', blogPost.noOfTies);
  //const [noOfTies, setNoOfTies] = React.useState(blogPost.noOfTies);
  const selectedWinnerPrizeMoney = watch(
    'WinnerPrizeMoney',
    blogPost.winnerPrizeMoney,
  );
  //const [winnerPrizeMoney, setWinnerPrizeMoney] = React.useState(
  //  blogPost.winnerPrizeMoney,
  //);
  const selectedLoserPrizeMoney = watch(
    'LoserPrizeMoney',
    blogPost.loserPrizeMoney,
  );
  //const [loserPrizeMoney, setLoserPrizeMoney] = React.useState(
  //  blogPost.loserPrizeMoney,
  //);
  const selectedOtherText = watch('OtherText', blogPost.otherText);
  //const [otherText, setOtherText] = React.useState(blogPost.otherText);
  /*
  const handleSeasonChange = (ev: any) => {
    setSelectedSeason(ev.target.value);
    setUpdatedBlogPost({...updatedBlogPost, season: ev.target.value});
  };
  const handleCompChange = (ev: any) => {
    setSelectedComp(ev.target.value);
    setUpdatedBlogPost({
      ...updatedBlogPost,
      comp: getFAComp(ev.target.value)?.comp!,
    });
  };
  const handleRoundChange = (ev: any) => {
    setSelectedRound(ev.target.value);
    setUpdatedBlogPost({...updatedBlogPost, roundName: ev.target.value});
  };
  const handleTitleChange = (ev: any) => {
    setTitle(ev.target.value);
    setUpdatedBlogPost({...updatedBlogPost, title: ev.target.value});
  };
  const handleRoundDateChange = (ev: any) => {
    setRoundDate(ev.target.value);
    setUpdatedBlogPost({...updatedBlogPost, roundDate: ev.target.value});
  };
  const handleNoOfTiesChange = (ev: any) => {
    setNoOfTies(ev.target.value);
    setUpdatedBlogPost({
      ...updatedBlogPost,
      noOfTies: parseInt(ev.target.value),
    });
  };
  const handleWinnerPrizeMoneyChange = (ev: any) => {
    setWinnerPrizeMoney(ev.target.value);
    setUpdatedBlogPost({
      ...updatedBlogPost,
      winnerPrizeMoney: parseFloat(ev.target.value),
    });
  };
  const handleLoserPrizeMoneyChange = (ev: any) => {
    setLoserPrizeMoney(ev.target.value);
    setUpdatedBlogPost({
      ...updatedBlogPost,
      loserPrizeMoney:
        ev.target.value === '' ? null : parseFloat(ev.target.value),
    });
  };
*/
  const generateBlogPostContent = (_updatedBlogPost: FACompBlogContentType) => {
    //console.log('Gernerate Blog Post');
    //console.log(_updatedBlogPost.title);
    //console.log('After GenerateBlogPost');
    setGeneratedBlogPostContent(
      generateBlogPostContentFromCompBlogPost(_updatedBlogPost),
    );
  };
  //const generatedBlogPostContent =
  //  generateBlogPostContentFromCompBlogPost(undefined);

  React.useEffect(() => {
    const initForm = () => {
      setUpdatedBlogPost(blogPost);
      setValue('Season', blogPost.season);
      setValue('IsPublished', blogPost.isPublished);
      setValue('Comp', getFACompByType(blogPost!.comp)!.name);
      setValue('Title', blogPost.title);
      setValue(
        'PubDate',
        blogPost.pubDate !== ''
          ? blogPost.pubDate
          : publishedDate(blogPost.roundDate),
      );
      setValue('Round', blogPost.roundName);
      setValue('RoundDate', blogPost.roundDate);
      setValue('NoOfTies', blogPost.noOfTies);
      setValue('WinnerPrizeMoney', blogPost.winnerPrizeMoney);
      setValue('LoserPrizeMoney', blogPost.loserPrizeMoney);
      setValue('Categories', blogPost.categories);
      setValue('OtherText', blogPost.otherText);
      //setGeneratedBlogPostContent(generatedBlogPostContent);
      //setInitInputForm(false);
    };
    initForm();
    setInitInputForm(false);
  }, [
    blogPost,
    setInitInputForm,
    initInputForm,
    setGeneratedBlogPostContent,
    setValue,
  ]);
  //console.log({selectedCategories});
  const onSubmit: SubmitHandler<ICompInputFormValues> = data => {
    //alert(selectedCategories);
    let _updatedBlogPost = {
      ...updatedBlogPost,
      season: selectedSeason,
      isPublished: selectedIsPublished,
      comp: getFAComp(selectedComp)?.comp!,
      title: selectedTitle,
      roundName: selectedRound,
      noOfTies: selectedNoOfTies,
      winnerPrizeMoney: selectedWinnerPrizeMoney,
      loserPrizeMoney: selectedLoserPrizeMoney,
      categories: selectedCategories,
      pubDate: selectedPubDate,
      otherText: selectedOtherText,
    };
    setUpdatedBlogPost(_updatedBlogPost);
    generateBlogPostContent(_updatedBlogPost);
  };
  return (
    <section id="enterfacomp">
      <h3>Blog Comp Details</h3>
      <form
        className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 flex flex-col"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">
            Season
          </label>

          <BlogPostSelectSeasonV3
            register={register}
            setValue={setValue}
            selectedSeason={selectedSeason}
          />
        </div>

        <BlogPostSelectCompBaseV2
          register={register}
          setValue={setValue}
          selectedSeason={selectedSeason}
          selectedComp={selectedComp}
        />

        <BlogPostSelectRoundBaseV2
          register={register}
          setValue={setValue}
          selectedSeason={selectedSeason}
          selectedComp={selectedComp}
          selectedRound={selectedRound}
        />
        <BlogPostTextInputV2
          register={register}
          defaultValue={selectedPubDate}
          name="PubDate"
          label="Published Date"
        />

        <BlogPostCheckBox
          register={register}
          defaultValue={true}
          name="IsPublished"
          label="Published"
          checked={selectedIsPublished}
        />
        <BlogPostSelectCategories
          register={register}
          selectedCategories={selectedCategories}
          name="Categories"
          label="Categories"
        />

        <BlogPostTextInputV2
          register={register}
          defaultValue={selectedTitle}
          name="Title"
          label="Title"
        />
        <BlogPostTextInputV2
          register={register}
          defaultValue={selectedRoundDate}
          name="RoundDate"
          label="Round Date"
        />
        <BlogPostTextInputV2
          register={register}
          defaultValue={selectedNoOfTies.toString()}
          name="NoOfTies"
          label="No Of Ties"
        />
        <BlogPostTextInputV2
          register={register}
          defaultValue={selectedWinnerPrizeMoney.toString()}
          name="WinnerPrizeMoney"
          label="Winner Prize Money"
        />
        <BlogPostTextInputV2
          register={register}
          defaultValue={
            selectedLoserPrizeMoney === undefined ||
            selectedLoserPrizeMoney === null
              ? '0'
              : selectedLoserPrizeMoney!.toString()
          }
          name="LoserPrizeMoney"
          label="Loser Prize Money"
        />

        <BlogPostTextInputV2
          register={register}
          defaultValue={selectedOtherText}
          name="OtherText"
          label="Other Content"
        />

        <button
          type="submit"
          className="flex-shrink-0 bg-green-500 hover:bg-green-700 border-green-500 hover:border-green-700 text-sm border-4 text-white py-1 px-2 rounded uppercase"
        >
          generate
        </button>
      </form>
    </section>
  );
};

export default BlogPostNewFACompInputFormV2;
